<template>
  <div class="m_ooplist">
    <van-nav-bar title="" />
    <van-nav-bar
      :title="topTitle"
      left-arrow
      @click-left="onClickLeft"
      class="topTitle"
    />

    <van-list>
      <van-cell
        v-for="item in contentList"
        :key="item.BusinessID"
        :title="item.BusinessName"
        @click="entryDetail(item.BusinessID)"
      />
    </van-list>

    <div>
      <van-pagination
        v-model="currentPage"
        :total-items="totalItem"
        :items-per-page="10"
        v-show="totalItem > 10"
      />
    </div>

    <div class="m_bottom">版权所有 © 2021 河南大学教务处</div>
  </div>
</template>

<script>
import { findItembySubclassId } from "../../utils/api.js";
export default {
  name: "m_ooplist",
  mounted: function () {
    console.log("从vuex中获取到的对象", this.$store.state.role);
    this.topTitle = this.$store.state.role;
    // console.log("从menu中传过来的二级菜单id", this.$route.params.subClassId);
    console.log("从vuex中获取到二级菜单id", this.$store.state.subClassId);

    console.log(
      "二级菜单ID:",
      this.$store.state.subClassId,
      "角色:",
      this.$store.state.roleCode,
      "页面:",
      this.currentPage
    );

    //该函数三个参数 二级菜单ID，角色，当前页面
    findItembySubclassId(
      this.$store.state.subClassId,
      this.$store.state.roleCode,
      this.currentPage
    ).then((result) => {
      console.log(result);
      this.totalItem = result.totalItem;
      this.contentList = result.contentList;
    });
  },
  data() {
    return {
      //最上面标题显示的内容
      topTitle: "",
      list: [1, 2, 3, 4, 5, 6, 17, 8, 9, 10],
      currentPage: 1,
      //列表要展示的总数据数
      totalItem: 0,
      //列表要显示的所有东西在此列表
      contentList: [
        // {
        //   BusinessClass: "1",
        //   BusinessDepartment: "11",
        //   BusinessID: "10",
        //   BusinessName: "保留入学资格",
        //   BusinessObject: "10",
        //   ClassID: "1",
        //   ClassName: "学籍管理",
        //   Department: "11",
        //   ObjectName: "学生",
        //   SubClassName: "保留入学资格",
        // },
      ],
    };
  },
  methods: {
    //van-nav-bar左侧点击返回
    onClickLeft: function () {
      console.log("ooplist点击了返回 返回上一页menu");
      this.$router.replace("./m_menu");
    },
    //点击列表事项进入详情页
    entryDetail: function (articleId) {
      console.log("列表页点击了", articleId);
      // this.$router.replace("./detail");
      this.$router.replace({
        path: "./m_detail",
        name: "m_detail",
        params: {
          inRole: "oopList",
          role: this.$store.state.roleCode,
          articleID: articleId,
        },
      });
    },
  },
};
</script>

<style>
.m_bottom {
  position: absolute;
  top: 93%;
  width: 100%;
  text-align: center;
  font-weight: 300;
  font-size: 20px;
  color: #999999;
  line-height: 48px;
}
.m_ooplist {
  text-align: left;
  background: #FFF;
  width: 100vw;
  height: 100vh;
}
.van-nav-bar__arrow {
  font-size: 20px;
}
.van-nav-bar__content {
  padding: 5px 2px;
}
.van-nav-bar__title {
  font-size: 20px;
}
.van-cell__title,
.van-cell__value {
  font-size: large;
  color: #333333;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.m_bottom {
  position: absolute;
  top: 93%;
  width: 100%;
  text-align: center;
  font-weight: 300;
  font-size: 20px;
  color: #999999;
  line-height: 48px;
}
.van-nav-bar__arrow {
  font-size: 20px;
}
.van-nav-bar__content {
  padding: 5px 2px;
}
.van-nav-bar__title {
  font-size: 20px;
}
.van-cell {
  padding: 10px 20px;
  background: #f3f8fd;
}
.van-collapse-item__title--expanded {
  background: #f3f8fd;
}
.van-collapse-item__icon {
  display: none;
}
van-cell__right-icon {
  display: none;
}
.inBTM {
  position: fixed;
  bottom: 0;
  width: 100vw;
  height: 55px;
  line-height: 55px;
  background-color: whitesmoke;
  text-align: center;
  font-size: 14px;
  background-color: #09c;
  color: white;
}
.topTitle {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}
</style>